import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { baseUrl } from "../../../../../config/Common";
import { setAllStaffs } from "./staffSlice";
import {
  handleError,
} from "../../../Common/Alerts/errorhandling.action";
import { setShowError} from "../../../Common/Alerts/alertsSlice";
import {
  customRequest,
  deleteData,
  getData,
  postData,
  putData,
} from "../../../../../services/apiEndpoints";
import { getAY } from "../../../../../Utils/academivYear";
import { getUserRole } from "../../../../../Utils/getRoles";

// Fetch All Staff
export const fetchAllStaff = createAsyncThunk(
  "user/allStaff",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      const say = getAY();
      dispatch(setShowError(false));
      const getRole = getUserRole(getState);
      const response = await getData(`/${getRole}/get_staffs?say=${say}`);
      dispatch(setAllStaffs(response));
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Add User
export const addUser = createAsyncThunk(
  "user/addUser",
  async ({ userData }, { rejectWithValue, getState, dispatch }) => {
    try {
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const response = await customRequest(
        "post",
        `/${getRole}/staff_register?say=${say}`,
        userData,
        {
          "Content-Type": "multipart/form-data",
        }
      );

      if (response.success) {
        toast.success("User added successfully");
        dispatch(fetchAllStaff());
      } else {
        toast.error(response.message);
      }

      dispatch(fetchAllStaff());

      //dispatch(createStaffSalary({ status: "unpaid", action: "pay now" }));
      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Edit User
export const editUser = createAsyncThunk(
  "user/editUser",
  async ({ userData, id }, { rejectWithValue, getState, dispatch }) => {
    try {
      const say = getAY();
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));

      const response = await customRequest(
        "put",
        `/${getRole}/update_staff/${id}?say=${say}`,
        userData,
        {
          "Content-Type": "multipart/form-data",
        }
      );

      if (response.success) {
        dispatch(fetchAllStaff());
      } else {
        toast.error(response.message);
      }

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Deactivate User
export const deactiveUser = createAsyncThunk(
  "user/deactiveUser",
  async (userData, { rejectWithValue, getState, dispatch }) => {
    try {
      const getRole = getUserRole(getState);
      dispatch(setShowError(false));
      const say = getAY();
      const response = await deleteData(
        `/${getRole}/delete_staff/${userData.id}?say=${say}`
      );

      if (response.success) {
        toast.success("User deactivated successfully");

        dispatch(fetchAllStaff());
      } else {
        toast.error(response.message || "User deactivation failed");
      }

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

// Activate User

export const activeUser = createAsyncThunk(
  "user/activeUser",
  async (userData, { rejectWithValue, getState, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const getRole = getUserRole(getState);
      const say = getAY();
      const response = await putData(
        `/${getRole}/update_active_status?say=${say}`,
        userData
      );

      if (response.success) {
        toast.success("User activated successfully");

        dispatch(fetchAllStaff());
      } else {
        toast.error(response.message || "User activation failed");
      }

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);
